<!-- Launch Button -->
<div class="launch-button-container">
  <button
    class="student-activity-launch-button launch-button"
    [ngClass]="getAssignmentLaunchButtonClass(assignment)"
    >
    <!-- Upcoming -->
    @if (
      assignment?.status === 'pending' &&
      assignment?.dueStatus !== 'overdue' &&
      !checkIfInProgress(assignment)
      ) {
      <span
        class="launch-button-inner-wrapper"
        ><span>Start</span
        ><mat-icon class="right-chevron-icon" aria-label="chevron right"
        >chevron_right</mat-icon
        ></span
        >
      }

      <!-- Overdue -->
      @if (
        assignment?.dueStatus === 'overdue' &&
        !assignment?.startedAt &&
        !assignment?.evaluatedAt
        ) {
        <span
          class="launch-button-inner-wrapper"
          >
          <span>Start</span>
          <mat-icon class="right-chevron-icon" aria-label="chevron right"
            >chevron_right</mat-icon
            >
          </span>
        }
        <!-- Overdue and In Progress -->
        @if (
          assignment?.dueStatus === 'overdue' &&
          checkIfInProgress(assignment)
          ) {
          <span
            class="launch-button-inner-wrapper"
            ><mat-icon class="resume-icon" aria-label="Restore"
            >restore</mat-icon
            >
            <span>Resume</span>
            <mat-icon class="right-chevron-icon" aria-label="chevron right"
              >chevron_right</mat-icon
              >
            </span>
          }

          <!-- In Progress -->
          @if (
            checkIfInProgress(assignment) &&
            assignment?.dueStatus !== 'overdue'
            ) {
            <span
              class="launch-button-inner-wrapper"
              ><mat-icon class="resume-icon" aria-label="Restore"
              >restore</mat-icon
              ><span>Resume</span
              ><mat-icon class="right-chevron-icon" aria-label="chevron right"
              >chevron_right</mat-icon
              ></span
              >
            }

            <!-- Submitted -->
            @if (
              assignment?.completedAt &&
              !assignment.evaluatedAt &&
              (assignment?.dueStatus !== 'overdue' ||
              !checkIfInProgress(assignment))
              ) {
              <span
                class="launch-button-inner-wrapper"
                ><span>Review</span
                ><mat-icon class="right-chevron-icon" aria-label="chevron right"
                >chevron_right</mat-icon
                ></span
                >
              }

              <!-- Evaluated -->
              @if (
                assignment?.completedAt &&
                assignment?.evaluatedAt &&
                (assignment?.dueStatus !== 'overdue' ||
                !checkIfInProgress(assignment))
                ) {
                <span
                  class="launch-button-inner-wrapper"
                  ><span>Review</span
                  ><mat-icon class="right-chevron-icon" aria-label="chevron right"
                  >chevron_right</mat-icon
                  ></span
                  >
                }

                <!-- Evaluated and NOT Submitted -->
                @if (
                  !assignment?.completedAt &&
                  assignment?.evaluatedAt &&
                  !checkIfInProgress(assignment)
                  ) {
                  <span
                    class="launch-button-inner-wrapper"
                    ><span>Start</span
                    ><mat-icon class="right-chevron-icon" aria-label="chevron right"
                    >chevron_right</mat-icon
                    ></span
                    >
                  }
                </button>
              </div>
